document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.href.includes('apps/customers')) return;
  document.querySelector('.header__icon.header__icon--cart')?.setAttribute('href','/cart?view=FLONEW');
  const POLL_MS = 400, MAIN_TIMEOUT = 20000;
  const CAROUSEL = '.__carousel_content';
  const CLICK_RETRIES = 8, CLICK_INTERVAL = 300;
  let mainInterval = null, clickInterval = null, clickAttempts = 0, busy = false;

  const hideNode = n => {
    if (!n) return false;
    try {
      n.style.display = 'none';
      n.style.pointerEvents = 'none';
      n.setAttribute('aria-hidden', 'true');
      return true;
    } catch (e) { return false; }
  };

  function hideCarousel() {
    if (busy) return false;
    const c = document.querySelector(CAROUSEL);
    if (!c) return false;
    busy = true;
    try {
      const wrap = c.parentElement?.parentElement;
      if (wrap) {
        const prev = wrap.previousSibling;
        if (prev) hideNode(prev);
        hideNode(wrap);
      } else {
        hideNode(c);
      }
    } finally { setTimeout(() => { busy = false; }, 20); }
    return true;
  }

  function hideReactivateButtons() {
    document.querySelectorAll('button').forEach(btn => {
      if ((btn.textContent || '').trim().toLowerCase().includes('reactivate')) hideNode(btn);
    });
  }

  function checkAndHideAll() {
    if (busy) return false;
    hideCarousel();
    hideReactivateButtons();
    return true;
  }

  function startClickPoll() {
    if (clickInterval) clearInterval(clickInterval);
    clickAttempts = 0;
    clickInterval = setInterval(() => {
      clickAttempts++;
      checkAndHideAll();
      if (clickAttempts >= CLICK_RETRIES) { clearInterval(clickInterval); clickInterval = null; }
    }, CLICK_INTERVAL);
  }

  const onDocClick = () => { checkAndHideAll(); startClickPoll(); };
  document.addEventListener('click', onDocClick);

  mainInterval = setInterval(checkAndHideAll, POLL_MS);
  setTimeout(() => { if (mainInterval) { clearInterval(mainInterval); mainInterval = null; } }, MAIN_TIMEOUT);

  checkAndHideAll();

  const cleanupAll = () => {
    if (mainInterval) clearInterval(mainInterval);
    if (clickInterval) clearInterval(clickInterval);
    document.removeEventListener('click', onDocClick);
    window.removeEventListener('beforeunload', cleanupAll);
  };
  window.addEventListener('beforeunload', cleanupAll);
});
